export default __webpack_public_path__ + "static/media/tuto-step-4.37b9864b.gif";